import { QuestionItem } from "./Components/TopicPreview";
import { BaseQuestionType, QuestionBaseList } from "service/exercise";

export function question2Exercise(data: QuestionBaseList): QuestionItem {
    const questionItem: QuestionItem = {
        queTypeId: BaseQuestionType.SingleChoice,
        score: "1",
        contentText:
            "美国作家艾斯蒂·希斯曾在作品里这样描写她:“她雍容华贵，却又那么朴实无华，堪称稳重端庄。在欧洲的王子和公主中，尤其年龄较长者的身上，偶尔也能看到同样的影响力。",
        queTypeName: "单选题",
        optionModelList: [
            {
                id: 0,
                description:
                    "美国作家艾斯蒂·希斯曾在作品里这样描写她:“她雍容华贵，却又那么朴实无华，堪称稳重端庄。在欧洲的王子和公主中，尤其年龄较长者的身上，偶尔也能看到同样的影响力。",
                isRight: true
            },
            {
                id: 1,
                description:
                    "美国作家艾斯蒂·希斯曾在作品里这样描写她:“她雍容华贵，却又那么朴实无华，堪称稳重端庄。在欧洲的王子和公主中，尤其年龄较长者的身上，偶尔也能看到同样的影响力。",
                isRight: false
            },
            {
                id: 2,
                description:
                    "美国作家艾斯蒂·希斯曾在作品里这样描写她:“她雍容华贵，却又那么朴实无华，堪称稳重端庄。在欧洲的王子和公主中，尤其年龄较长者的身上，偶尔也能看到同样的影响力。",
                isRight: false
            },
            {
                id: 3,
                description:
                    "美国作家艾斯蒂·希斯曾在作品里这样描写她:“她雍容华贵，却又那么朴实无华，堪称稳重端庄。在欧洲的王子和公主中，尤其年龄较长者的身上，偶尔也能看到同样的影响力。",
                isRight: false
            }
        ]
    };

    const mock: QuestionItem = {
        queTypeId: BaseQuestionType.Mixed,
        score: "10",
        contentText:
            "美国作家艾斯蒂·希斯曾在作品里这样描写她:“她雍容华贵，却又那么朴实无华，堪称稳重端庄。在欧洲的王子和公主中，尤其年龄较长者的身上，偶尔也能看到同样的影响力。",
        queTypeName: "阅读理解",
        optionModelList: [],
        questionModelList: [questionItem, questionItem]
    };

    return mock;
}
